// src/menu/sections/hostMenu.ts
import type { AppMenuEntry } from "../types";

export const HOST_MENU: AppMenuEntry = {
  type: "group",
  key: "Host",
  label: "Host",
  icon: "desktop",
  children: [
    {
      key: "hosts",
      label: "Hosts",
      path: "/hosts",
      resource: "hosts",
      icon: "desktop",
    },
    {
      key: "commands",
      path: "/commands",
      label: "Commands",
      resource: "commands",
      icon: "code",
    },
    {
      key: "command_runs",
      path: "/command_runs",
      label: "Command Runs",
      resource: "command_runs",
      icon: "securityscan",
    },
    {
      key: "command_groups",
      path: "/command_groups",
      label: "Command Groups",
      resource: "command_groups",
      icon: "group",
    },
    {
      key: "command_group_commands",
      path: "/command_group_commands",
      label: "Command Group Commands",
      resource: "command_group_commands",
      icon: "code",
    },
    /*
    {
      key: "host_certs",
      path: "/host_certs",
      label: "Host Certs",
      resource: "host_certs",
    },
    {
      key: "host_keys",
      path: "/host_keys",
      label: "Host Keys",
      resource: "host_keys",
    },
*/
    {
      key: "host_key_automations",
      path: "/host_key_automations",
      label: "Host Key Automations",
      resource: "host_key_automations",
      icon: "key",
    },
    {
      key: "host_key_automation_commands",
      path: "/host_key_automation_commands",
      label: "Host Key Automation Commands",
      resource: "host_key_automation_commands",
      icon: "code",
    },
    {
      key: "os_discovery_debug",
      path: "/os_discovery_debug",
      label: "OS Discover Debug",
      resource: "os_discovery_debug",
      icon: "scan",
    },
  ],
};
